// This file will be automatically created by jenkins, based on the parameters passed to the build job.
module.exports = {
    version: '',
    microApps: '',
}
